import { AgenticScoreBucket } from "@/types";

// Buckets the raw 1-5 agentic score into Excellent / Great / Good / Okay.
// 5 = Excellent, 4 = Great, 3 = Good, 1-2 = Okay. Returns null for missing scores.
export const agenticScoreToBucket = (
  score: number | null | undefined,
): AgenticScoreBucket | null => {
  if (score === null || score === undefined) return null;
  if (score >= 5) return AgenticScoreBucket.EXCELLENT;
  if (score === 4) return AgenticScoreBucket.GREAT;
  if (score === 3) return AgenticScoreBucket.GOOD;
  if (score >= 1) return AgenticScoreBucket.OKAY;
  return null;
};

// Raw 1-5 score stored when a human overrides to a given bucket. Chosen so the
// override round-trips back to the same bucket via agenticScoreToBucket.
export const agenticBucketToScore: Record<AgenticScoreBucket, number> = {
  [AgenticScoreBucket.OKAY]: 1,
  [AgenticScoreBucket.GOOD]: 3,
  [AgenticScoreBucket.GREAT]: 4,
  [AgenticScoreBucket.EXCELLENT]: 5,
};

export const agenticBucketToLabel: Record<AgenticScoreBucket, string> = {
  [AgenticScoreBucket.OKAY]: "Okay",
  [AgenticScoreBucket.GOOD]: "Good",
  [AgenticScoreBucket.GREAT]: "Great",
  [AgenticScoreBucket.EXCELLENT]: "Excellent",
};

// Buckets shown in the agentic rating dropdown, worst → best.
export const AGENTIC_SCORE_OPTIONS: AgenticScoreBucket[] = [
  AgenticScoreBucket.OKAY,
  AgenticScoreBucket.GOOD,
  AgenticScoreBucket.GREAT,
  AgenticScoreBucket.EXCELLENT,
];
